// extracted by mini-css-extract-plugin
export default {"block":"General_block__sKa5i"};